var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file Drawer组件
 * @author (wangzichuan)
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { classPrefix, contains, scrollWheel } from '../../common/util';

import './Drawer.less';

/* global window */

/**
 * 参数说明
 * visible    drawer是否展现
 * width      宽度，placement为left、right时起效
 * height     高度，placement为top、bottom时起效
 * zIndex     弹出层z-index值
 * placement  弹出方向，'top', 'right', 'bottom', 'left'
 * onClose    关闭时的回调
 */

var Drawer = function (_Component) {
    _inherits(Drawer, _Component);

    function Drawer() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Drawer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Drawer.__proto__ || Object.getPrototypeOf(Drawer)).call.apply(_ref, [this].concat(args))), _this), _this.bodyOnClick = function (e) {
            if (contains(_this.content, e.target)) {
                return;
            }
            _this.props.bodyOnClick && _this.props.bodyOnClick();
        }, _this.closeDrawer = function () {
            scrollWheel.scrollEnable(); // 解除阻止body滚动
            _this.props.onClose && _this.props.onClose(false);
        }, _this.showDrawer = function () {
            scrollWheel.scrollPrevent(); // 阻止body滚动
            _this.props.onOpen && _this.props.onOpen(true);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Drawer, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(np) {
            if (np.visible) {
                this.showDrawer();
            } else {
                this.closeDrawer();
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.addEventListener('click', this.bodyOnClick);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('click', this.bodyOnClick);
        }
    }, {
        key: 'getContentStyle',
        value: function getContentStyle() {
            var _contentStyle;

            var _props = this.props,
                placement = _props.placement,
                zIndex = _props.zIndex,
                visible = _props.visible;


            var contentStyle = {};
            var widthOrHeight = '';
            var widthOrHeightValue = 0;

            switch (placement) {
                case 'left':
                case 'right':
                    widthOrHeight = 'width';
                    break;
                case 'top':
                case 'bottom':
                    widthOrHeight = 'height';
                    break;
            }

            widthOrHeightValue = this.props[widthOrHeight];

            contentStyle = (_contentStyle = {
                zIndex: zIndex
            }, _defineProperty(_contentStyle, widthOrHeight, widthOrHeightValue), _defineProperty(_contentStyle, placement, visible ? 0 : -widthOrHeightValue), _contentStyle);

            return contentStyle;
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames,
                _this2 = this;

            var _props2 = this.props,
                children = _props2.children,
                className = _props2.className,
                visible = _props2.visible;


            var wrapperCls = classnames((_classnames = {}, _defineProperty(_classnames, className, !!className), _defineProperty(_classnames, classPrefix + '-drawer', true), _classnames));

            var maskCls = classPrefix + '-drawer-mask';
            var contentCls = classPrefix + '-drawer-content';

            var contentStyle = this.getContentStyle();

            return React.createElement(
                'div',
                { className: wrapperCls },
                visible && React.createElement('div', { className: maskCls }),
                React.createElement(
                    'div',
                    {
                        className: contentCls,
                        style: contentStyle,
                        ref: function ref(el) {
                            _this2.content = el;
                        }
                    },
                    children
                )
            );
        }
    }]);

    return Drawer;
}(Component);

Drawer.propTypes = {
    visible: PropTypes.bool,
    width: PropTypes.number,
    height: PropTypes.number,
    className: PropTypes.string,
    zIndex: PropTypes.number,
    placement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
    onClose: PropTypes.func,
    onOpen: PropTypes.func,
    children: PropTypes.node,
    classPrefix: PropTypes.string,
    bodyOnClick: PropTypes.func
};
Drawer.defaultProps = {
    classPrefix: classPrefix,
    width: 200,
    height: 200,
    zIndex: 999,
    placement: 'left'
};
export default Drawer;